import React from "react";
import ReactDOM from 'react-dom';
import { RegistrationApplication } from 'com.qantas.freight.user-widgets';
import {config} from './endpoint.js';
import {CssLoader} from 'com.qantas.freight.widget-core-framework/dist/css-loader';
import * as DateTimeFn from "com.qantas.freight.widget-core-framework/core/modules/DateTimeFn";

import "com.qantas.freight-ui/dist/css/static.css";

if (window.sqwidget) {
    window.sqwidget.define("main", [], function () {
        return function (settings) {
          new CssLoader().load(settings.config.host + "/freight/widgets/css/user_widgets.css");
            ReactDOM.render(
                <RegistrationApplication config={settings.config}/>,
                document.getElementById(settings.config['reactid'])
            );
        };
    });
} else {
    new CssLoader().load("/freight/widgets/css/user_widgets.css");
    ReactDOM.render(
        <RegistrationApplication config={config} />,
        document.getElementById('root')
    );
}